import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { DownloadIcon } from '../../../../../../utils/Icons';

import Classes from "../Profile.module.css";

const defaultAvatar = "/assets/images/user.png";

export default function BasicInfo({ initial, uploadMedia, saveProfile }) {
  const { user } = useSelector((s) => s.auth);

  const [data, setData] = useState({
    name: initial?.name || user.fullname || "",
    title: initial?.title || "",
    education: initial?.education || "",
    clubs: initial?.clubs || "",
    bio: initial?.bio || "",
    avatar: initial?.avatar || "",
    school: initial?.school || "",
    company: initial?.company || ""
  });
  const [avatarFile, setAvatarFile] = useState(null);
  const [preview, setPreview] = useState(initial?.avatar || defaultAvatar);
  const [loading, setLoading] = useState(false);

  const MAX = 1000;

  const handleChange = (e) =>
    setData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleBioChange = (e) => {
    let { value } = e.target;
    if (value.length > MAX) value = value.slice(0, MAX);
    setData((p) => ({ ...p, bio: value }));
  };

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setAvatarFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const onSave = async (e) => {
    e.preventDefault();

    let avatarUrl = preview;
    if (avatarFile) {
      avatarUrl = await uploadMedia([avatarFile], setLoading);
    }

    await saveProfile({
      basicInfo: { ...data, avatar: avatarUrl },
    });

  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={onSave}>
        <div><h3>Basic Information</h3></div>

        {/* picture */}
        <div className={Classes.changePicCon}>
          <img
            src={preview || defaultAvatar}
            alt="avatar"
            className={Classes.avatar}
            width={60}
            height={60}
            draggable={false}
          />
          <div className={Classes.picActions}>
            <h5 className={Classes.label}>Change Picture</h5>
            <label htmlFor="avatar-input" className={Classes.uploadBtn}>
              <DownloadIcon height="13" width="13" fill="#fff" />
              <h5>Upload Photo</h5>
              <input
                id="avatar-input"
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
            </label>
          </div>
        </div>

        {/* fields */}
        <div className={Classes.infoConMiddle}>
          {[
            ["name", "Name", "Enter name"],
            ["title", "Professional Title", "Enter job title"],
            ["company", "Company", "Enter company"],
            ["education", "Education Level", "Enter education level"],
            ["school", "School", "Enter school"],
            ["clubs", "Clubs, Fraternities, and Charities", "Enter clubs, charities, or fraternities"],
          ].map(([key, label, ph]) => (
            <div key={key} className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <div className="flexAlign10">
                  <h5 className={Classes.label}>{label}</h5>
                  {key === "clubs" &&
                    <div className="optionalText"><h5>Optional</h5></div>
                  }
                </div>
                <input
                  name={key}
                  className={Classes.inputField}
                  placeholder={ph}
                  value={data[key]}
                  onChange={handleChange}
                  required={key !== "clubs"}
                />
              </div>
            </div>
          ))}

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Short Bio</h5>
              <div className={Classes.textAreaCon}>
                <textarea
                  name="bio"
                  className={Classes.textArea}
                  rows={5}
                  placeholder="Enter bio"
                  value={data.bio}
                  onChange={handleBioChange}
                />
                <h5>{MAX - data.bio.length} Characters Remaining</h5>
              </div>
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
